// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__1UzXs","logo":"Footer_logo__3ACxa","text":"Footer_text__BdXqz","inner":"Footer_inner__28Rmf"};